<template>
  <div id="secure-dataflow-menu">
    <a href="#" class="menu-btn" @click.stop="clickMenu">
      <feather-icon
        class="menu-icon cursor-pointer"
        icon="MenuIcon"
        svg-classes="h-10 w-10 stroke-current text-white"
      />
    </a>

    <vs-sidebar
      click-not-close
      hidden-background
      position-left
      v-model="_isShowMenu"
      class="items-no-padding"
    >
      <div class="h-full">
        <div id="header-menu">
          <vs-row vs-w="12">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-w="10"
            >
              <div class="header-menu-padding">
                <span class="sdf-text-18-700-white ml-4">陸上監視システム</span>
              </div>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="flex-start"
              vs-w="2"
            >
              <feather-icon
                icon="XIcon"
                @click.stop="clickClose"
                class="cursor-pointer close-icon"
                svg-classes="h-8 w-8 stroke-current text-white"
              ></feather-icon>
            </vs-col>
          </vs-row>
        </div>

        <vs-divider color="#F2F2F2" class="mt-0 mb-0" />

        <component
          :is="scrollbarTag"
          class="scroll-area--secure-dataflow-menu"
          :settings="settings"
          :key="$vs.rtl"
        >
          <div id="transition-menu" class="px-2">
            <router-link
              :to="{ name: 'addon-secure-dataflow-monitoring-vessel-handling' }"
              custom
              v-slot="{ navigate, isActive, isExactActive }"
              @click.native="onTransition"
            >
              <div
                class="cursor-pointer transition-menu-padding"
                :class="[isActive && 'router-link-active', isExactActive && 'router-link-exact-active']"
                :active="isActive"
                @click="navigate"
              >
                <vs-row class="cursor-pointer" vs-w="12">
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="1"
                  >
                    <feather-icon
                      icon="ActivityIcon"
                      svg-classes="h-6 w-6 stroke-current text-white"
                    />
                  </vs-col>
                  <vs-col vs-type="flex" vs-align="center" vs-w="10">
                    <span class="sdf-text-16-400-white ml-4"
                      >航行監視ダッシュボード</span
                    >
                  </vs-col>
                </vs-row>
              </div>
            </router-link>
            <router-link
              :to="{ name: 'addon-secure-dataflow-alert-summary' }"
              custom
              v-slot="{ navigate, isActive, isExactActive }"
              @click.native="onTransition"
            >
              <div
                class="cursor-pointer transition-menu-padding"
                :class="[isActive && 'router-link-active', isExactActive && 'router-link-exact-active']"
                :active="isActive"
                @click="navigate"
              >
                <vs-row class="cursor-pointer" vs-w="12">
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="1"
                  >
                    <feather-icon
                      icon="AlertCircleIcon"
                      svg-classes="h-6 w-6 stroke-current text-white"
                    />
                  </vs-col>
                  <vs-col vs-type="flex" vs-align="center" vs-w="10">
                    <span class="sdf-text-16-400-white ml-4"
                      >アラートサマリー</span
                    >
                  </vs-col>
                </vs-row>
              </div>
            </router-link>

            <router-link
              :to="{ name: 'addon-secure-dataflow-event-summary' }"
              custom
              v-slot="{ navigate, isActive, isExactActive }"
              @click.native="onTransition"
            >
              <div
                class="cursor-pointer transition-menu-padding"
                :class="[isActive && 'router-link-active', isExactActive && 'router-link-exact-active']"
                :active="isActive"
                @click="navigate"
              >
                <vs-row class="cursor-pointer" vs-w="12">
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="1"
                  >
                    <feather-icon
                      icon="CheckCircleIcon"
                      svg-classes="h-6 w-6 stroke-current text-white"
                    />
                  </vs-col>
                  <vs-col vs-type="flex" vs-align="center" vs-w="10">
                    <span class="sdf-text-16-400-white ml-4"
                      >イベントサマリー</span
                    >
                  </vs-col>
                </vs-row>
              </div>
            </router-link>

            <router-link
              :to="{ name: 'addon-secure-dataflow-monitoring-vessel-engine' }"
              custom
              v-slot="{ navigate, isActive, isExactActive }"
              @click.native="onTransition"
            >
              <div
                class="cursor-pointer transition-menu-padding"
                :class="[isActive && 'router-link-active', isExactActive && 'router-link-exact-active']"
                :active="isActive"
                @click="navigate"
              >
                <vs-row vs-w="12">
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="1"
                  >
                    <feather-icon
                      icon="ClipboardIcon"
                      svg-classes="h-6 w-6 stroke-current text-white"
                    />
                  </vs-col>
                  <vs-col vs-type="flex" vs-align="center" vs-w="10">
                    <span class="sdf-text-16-400-white ml-4"
                      >トレンドデータレポート</span
                    >
                  </vs-col>
                </vs-row>
              </div>
            </router-link>

            <div
              class="cursor-pointer transition-menu-padding"
              @click="openCctv"
            >
              <vs-row vs-w="12">
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-w="1"
                >
                  <feather-icon
                    icon="VideoIcon"
                    svg-classes="h-6 w-6 stroke-current text-white"
                  />
                </vs-col>
                <vs-col vs-type="flex" vs-align="center" vs-w="10">
                  <span class="sdf-text-16-400-white ml-4"
                    >機関室CCTV</span
                  >
                </vs-col>
              </vs-row>
            </div>

            <router-link
              v-if="this.vesselInfo"
              :to="{
                name: 'enterprise-management-vessel-view',
                params: {
                  vesselId: this.vesselInfo.id,
                  fromSdfMenu: true
                }
              }"
              custom
              v-slot="{ navigate, isActive, isExactActive }"
              @click.native="onTransition"
            >
              <div
                class="cursor-pointer transition-menu-padding"
                :class="[isActive && 'router-link-active', isExactActive && 'router-link-exact-active']"
                :active="isActive"
                @click="navigate"
              >
                <vs-row vs-w="12">
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="1"
                  >
                    <feather-icon
                      icon="ListIcon"
                      svg-classes="h-6 w-6 stroke-current text-white"
                    />
                  </vs-col>
                  <vs-col vs-type="flex" vs-align="center" vs-w="10">
                    <span class="sdf-text-16-400-white ml-4">航海記録</span>
                  </vs-col>
                </vs-row>
              </div>
            </router-link>

            <router-link
              :to="{ name: 'addon-secure-dataflow-check-list-m0-check-list' }"
              custom
              v-slot="{ navigate, isActive, isExactActive }"
              @click.native="onTransition"
            >
              <div
                class="cursor-pointer transition-menu-padding"
                :class="[isActive && 'router-link-active', isExactActive && 'router-link-exact-active']"
                :active="isActive"
                @click="navigate"
              >
                <vs-row vs-w="12">
                  <vs-col
                    class="transition-menu-bottom-padding"
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="1"
                  >
                    <feather-icon
                      icon="CheckSquareIcon"
                      svg-classes="h-6 w-6 stroke-current text-white"
                    />
                  </vs-col>
                  <vs-col
                    class="transition-menu-bottom-padding"
                    vs-type="flex"
                    vs-align="center"
                    vs-w="10"
                  >
                    <span class="sdf-text-16-400-white ml-4"
                      >M0チェックリスト</span
                    >
                  </vs-col>
                </vs-row>
              </div>
            </router-link>
          </div>

          <div id="settings-menu" class="px-2">
            <div class="settings-menu-padding">
              <vs-row vs-w="12">
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-w="1"
                >
                  <feather-icon
                    icon="SettingsIcon"
                    svg-classes="h-6 w-6 stroke-current text-white"
                  />
                </vs-col>
                <vs-col vs-type="flex" vs-align="center" vs-w="10">
                  <span class="sdf-text-16-700-white ml-4">設定</span>
                </vs-col>
              </vs-row>
            </div>

            <div class="settings-menu-padding">
              <vs-row vs-w="12">
                <vs-col
                  vs-type="flex"
                  vs-justify="start"
                  vs-align="center"
                  vs-w="6"
                >
                  <span class="sdf-text-16-400-white">他船情報を表示</span>
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="center"
                  vs-w="6"
                >
                  <vs-switch
                    :color="this.sdfColor.Blue"
                    v-model="_isDisplayOtherVessels"
                  />
                </vs-col>
              </vs-row>
            </div>

            <div class="settings-menu-padding">
              <vs-row vs-w="12">
                <vs-col
                  vs-type="flex"
                  vs-justify="start"
                  vs-align="center"
                  vs-w="7"
                >
                  <h5 class="sdf-text-16-400-white">アラートサマリーの通知</h5>
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="center"
                  vs-w="5"
                >
                  <vs-switch
                    :color="this.sdfColor.Blue"
                    v-model="_onAlertSummaryNotification"
                  />
                </vs-col>
              </vs-row>
            </div>

            <div class="settings-menu-padding">
              <vs-row vs-w="12">
                <vs-col
                  vs-type="flex"
                  vs-justify="start"
                  vs-align="center"
                  vs-w="7"
                >
                  <h5 class="sdf-text-16-400-white">自船常時追尾</h5>
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="center"
                  vs-w="5"
                >
                  <vs-switch
                    :color="this.sdfColor.Blue"
                    v-model="_onVesselAutoTracking"
                  />
                </vs-col>
              </vs-row>
            </div>

            <div class="settings-menu-padding">
              <vs-row vs-w="12">
                <vs-col
                  vs-type="flex"
                  vs-justify="start"
                  vs-align="center"
                  vs-w="6"
                >
                  <h5 class="sdf-text-16-400-white">航跡保持時間</h5>
                </vs-col>
                <vs-col
                  class="pl-20"
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="center"
                  vs-w="6"
                >
                  <div style="width: 100%">
                    <v-select
                      class="track-history-interval-style sdf-text-16-400-white"
                      v-model="_trackHistoryInterval"
                      :options="trackHistoryIntervalOptions"
                      :clearable="false"
                      :searchable="false"
                    />
                  </div>
                </vs-col>
              </vs-row>
            </div>

            <div class="settings-menu-padding">
              <vs-row vs-w="12">
                <vs-col
                  vs-type="flex"
                  vs-justify="start"
                  vs-align="center"
                  vs-w="6"
                >
                  <h5 class="sdf-text-16-400-white">離着岸時の航跡表示間隔</h5>
                </vs-col>
                <vs-col
                  class="pl-20"
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="center"
                  vs-w="6"
                >
                  <div style="width: 100%">
                    <v-select
                      id="display-interval-input"
                      class="track-display-interval-style sdf-text-16-400-white"
                      v-model="_trackDisplayInterval"
                      :options="trackDisplayIntervalOptions"
                      :clearable="false"
                      :searchable="false"
                    />
                  </div>
                </vs-col>
              </vs-row>
            </div>
          </div>

          <div v-if="isDevelop" id="developer-tool-menu" class="px-2">
            <developer-tool-menu />
          </div>
        </component>
      </div>
    </vs-sidebar>
    <DialogSelectVessel ref="dialogSelectVessel" />
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";

import DeveloperToolMenu from "./components/DeveloperTool";
import DialogSelectVessel from "./components/DialogSelectVessel";
import environment from "@/environment/aisea";

// mixins
import {
  ColorMixin,
  StoreMenuMixin,
  StoreCommonsMixin
} from "@/mixins/addon/secure-dataflow";

export default {
  components: {
    VuePerfectScrollbar,
    vSelect,
    DeveloperToolMenu,
    DialogSelectVessel
  },
  props: {},
  mixins: [ColorMixin, StoreMenuMixin, StoreCommonsMixin],
  data() {
    return {
      trackDisplayIntervalOptions: [
        { val: 0, label: "非表示" },
        { val: 60, label: "1分" }
      ],
      trackHistoryIntervalOptions: [
        { val: 60, label: "1時間" },
        { val: 180, label: "3時間" },
        { val: 360, label: "6時間" }
      ],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 1,
        swipeEasing: true
      },
      isDevelop: environment.isDevelop(),
    };
  },
  watch: {
    showDialogSelectVessel(val) {
      if (val) {
        this.$refs.dialogSelectVessel.show();
      }
    }
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    _isShowMenu: {
      get() {
        return this.isShowMenu;
      },
      set(val) {
        this.SET_IS_SHOW_MENU(val);
      }
    },
    _isDisplayOtherVessels: {
      get() {
        return this.isDisplayOtherVessels;
      },
      set(val) {
        this.setIsDisplayOtherVessels(val);
      }
    },
    _onAlertSummaryNotification: {
      get() {
        return this.onAlertSummaryNotification;
      },
      set(val) {
        this.setOnAlertSummaryNotification(val);
      }
    },
    _onVesselAutoTracking: {
      get() {
        return this.onVesselAutoTracking;
      },
      set(val) {
        this.setVesselAutoTracking(val);
      }
    },
    _trackDisplayInterval: {
      get() {
        let targetTime = this.trackDisplayIntervalOptions.filter(option => {
          return option.val === this.trackDisplayInterval;
        });
        return targetTime;
      },
      set(time) {
        this.setTrackDisplayInterval(time.val);
      }
    },
    _trackHistoryInterval: {
      get() {
        let targetTime = this.trackHistoryIntervalOptions.filter(option => {
          return option.val === this.trackHistoryInterval;
        });
        return targetTime;
      },
      set(time) {
        this.setTrackHistoryInterval(time.val);
      }
    }
  },
  methods: {
    clickMenu() {
      this.SET_IS_SHOW_MENU(true);
    },
    clickClose() {
      this.SET_IS_SHOW_MENU(false);
    },
    onTransition() {
      this.SET_IS_SHOW_MENU(false);
    },
    openCctv() {
      window.open('https://soleil-cctv.aisea.app/', '_blank');
      this.SET_IS_SHOW_MENU(false);
    },
  },
  async created() {
    await this.setSdfMenuSettings();
  },
  async beforeDestroy() {
    await this.resetSdfMenuState;
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/secure-dataflow/menu.scss";
</style>
